import _default from './stripIndent';
export { _default as default };
